import { LineChart } from "lucide-react";
import { useApi } from "../../dashboard/api";
import { EmptyState, ErrorState, Panel, Skeleton } from "./ui";

const Chart = ({ points }) => {
    const W = 720;
    const H = 180;
    const max = Math.max(...points.map((p) => p.v), 1);
    const step = W / Math.max(points.length - 1, 1);
    const coords = points.map((p, i) => [i * step, H - (p.v / max) * (H - 24) - 8]);
    const line = coords.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)} ${y.toFixed(1)}`).join(" ");
    return (
        <svg viewBox={`0 0 ${W} ${H + 16}`} className="w-full" role="img" aria-label="Profit trend chart">
            <defs>
                <linearGradient id="pt-fill" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#B8FF18" stopOpacity="0.14" />
                    <stop offset="100%" stopColor="#B8FF18" stopOpacity="0" />
                </linearGradient>
            </defs>
            {[0.25, 0.5, 0.75].map((f) => (
                <line key={f} x1="0" x2={W} y1={H * f} y2={H * f} stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
            ))}
            <path d={`${line} L ${W} ${H} L 0 ${H} Z`} fill="url(#pt-fill)" />
            <path d={line} fill="none" stroke="#B8FF18" strokeWidth="1.5" strokeLinejoin="round" />
            {coords.map(([x, y], i) => (
                <circle key={i} cx={x} cy={y} r="2.5" fill="#B8FF18" />
            ))}
        </svg>
    );
};

export const TrendChart = () => {
    const { data, loading, error } = useApi("profit-history");
    return (
        <Panel title="Profit Trend" className="mt-6" testId="profit-trend">
            {loading ? (
                <Skeleton className="h-44 w-full" />
            ) : error ? (
                <ErrorState testId="profit-trend-error" />
            ) : !data?.points?.length ? (
                <EmptyState
                    icon={LineChart}
                    title="Not enough historical data"
                    desc="Profit history will appear here once your account has on-chain activity."
                    testId="profit-trend-empty"
                />
            ) : (
                <Chart points={data.points} />
            )}
        </Panel>
    );
};
